export default __webpack_public_path__ + "static/why-tecalis_01-424694e539ccb8e4eb5a5970ec4e1a67.png";